<template>
  <div class="cardGraphicComponent" id="grapic1" />
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import api from "../../services/axios";

export default {
  props: {
    selectedDate: {
      type: String,
      default: () => moment().format("YYYY-MM-DD"),
    },
    hideValues: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      dataSales: {},
      chart: null,
      resizeHandler: null,
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 0,
          data: ["Frente de Caixa", "Vendas", "Orçamentos"],
        },

        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        grid: {
          top: 56,
          left: 20,
          right: 20,
          bottom: 28,
          containLabel: true,
        },
        series: [
          {
            name: "Frente de Caixa",
            type: "bar",
            barGap: 0,
            label: this.labelOption,
            emphasis: {
              focus: "series",
            },
            data: [],
          },
          {
            name: "Vendas",
            type: "bar",
            label: this.labelOption,
            emphasis: {
              focus: "series",
            },
            data: [],
          },
          {
            name: "Orçamentos",
            type: "bar",
            label: this.labelOption,
            emphasis: {
              focus: "series",
            },
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    async obterDatas() {
      const dataAtual = moment(this.selectedDate);

      const dataAntes4Meses = dataAtual.clone().subtract(4, "months");
      this.startDate = dataAntes4Meses.format("YYYY-MM-DD");
      this.endDate = dataAtual.format("YYYY-MM-DD");

      await this.readSales(this.startDate, this.endDate);
    },
    async readSales(initial, finaly) {
      try {
        const { data } = await api.get(
          `/sales/search/per/month/sum/sales/by/dashboard/grapic?startDate=${initial}&endDate=${finaly}`
        );

        this.dataSales = data.data;
        this.updateChart();
      } catch (error) {
        console.error(error);
      }
    },
    updateChart() {
      const months = Object.keys(this.dataSales);

      const seriesData = Object.values(this.dataSales);
      const monthNames = months.map((month) =>
        moment(`${month}-01`, "MM").format("MMMM")
      );

      this.option.xAxis[0].data = monthNames;
      this.option.series[0].data = seriesData.map(
        (monthData) => monthData["Frente de caixa"] || 0
      );
      this.option.series[1].data = seriesData.map(
        (monthData) => monthData["Venda"] || 0
      );
      this.option.series[2].data = seriesData.map(
        (monthData) => monthData["Orçamento"] || 0
      );
      this.option.tooltip = {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params) => {
          const rows = params
            .map((item) => {
              const value = this.hideValues
                ? "R$ •••••"
                : Number(item.value || 0).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  });

              return `${item.marker}${item.seriesName}: <strong>${value}</strong>`;
            })
            .join("<br/>");

          return `${params[0].axisValue}<br/>${rows}`;
        },
      };
      this.option.yAxis[0].axisLabel = {
        formatter: this.hideValues ? "••••" : "{value}",
      };

      this.chart && this.chart.setOption(this.option);
    },
  },
  async mounted() {
    this.chart = echarts.init(document.getElementById("grapic1"));
    await this.obterDatas();
    this.option && this.chart.setOption(this.option);
    this.resizeHandler = () => this.chart && this.chart.resize();
    window.addEventListener("resize", this.resizeHandler);
  },
  watch: {
    selectedDate() {
      this.obterDatas();
    },
    hideValues() {
      this.updateChart();
    },
  },
  beforeDestroy() {
    if (this.chart) {
      window.removeEventListener("resize", this.resizeHandler);
      this.chart.dispose();
    }
  },
};
</script>
<style scoped>
.cardGraphicComponent {
  height: 100%;
  min-height: 300px;
}
</style>
